module.exports = __webpack_public_path__ + "img/company2.dfa6147c.jpg";